import gql from "graphql-tag";

export const updatePasswordQuery = gql`
  mutation updatePassword($password: String!, $newPassword: String!) {
    updatePassword(password: $password, newPassword: $newPassword)
  }
`;
